export default __webpack_public_path__ + "static/media/3.53e4ccb5.svg";